// extracted by mini-css-extract-plugin
export default {"tx":"ea4177d406","line":"b821047b47"};